import React from "react";

// reactstrap components
// import {
// } from "reactstrap";

// core components
import SolNavbar from "components/Navbars/SolNavbar.js";
import SolHeader from "components/Headers/SolHeader.js";
import SolFooter from "components/Footers/SolFooter.js";

function Index() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <SolNavbar useColor={false} />
      <div className='wrapper'>
        <SolHeader />
        <SolFooter />
      </div>
    </>
  );
}

export default Index;
